export const BLUE_TRIANGLE_UT = 'bttUT' as string;
export const BLUE_TRIANGLE_BTT_REGEX_MAPPING_PT = 'BTT_REGEX_MAPPING_PT';
export const BLUE_TRIANGLE_HOME_PAGE_NAME = 'HomePage';
export const BLUE_TRIANGLE_FALLBACK_PAGE_NAME = 'Otherpage';
export const BLUE_TRIANGLE_PAGE_TURN_KEY = 'BT_PAGE_TURN';
